// extracted by mini-css-extract-plugin
export default {"message-headline":"Message_message-headline__AHmBY"};